//export const API_PATH = 'https://www.acil.info/lg/lgapi/lg-apis.php?type='
export const API_PATH = 'https://www.lg.pinarecipe.com/admin/lgapi/lg-apis.php?type='
export const GOOGLE_API_PATH = 'https://maps.googleapis.com/maps/api/geocode/json?'//
export const IMAGE_PATH = 'https://lg.pinarecipe.com/public/images/'
